export default __webpack_public_path__ + "static/media/ZIMCS.9c3f93a1.png";